import { CountUp } from 'countup.js'
import { reducedMotion } from './breakpoints.js'
export const countUpCounter = (element) => {
    if (element) {
        const { start, end, decimals, duration, prefix, suffix } = element.dataset
        // The wrapping .js-key-stat-visual is aria-hidden (see Stat.ss) because
        // a live region on rapidly-changing counting text would announce every
        // intermediate frame - this sibling is only ever updated once, with the
        // final value, when the animation completes. It's read from its own
        // already-correct server-rendered text (rather than re-derived from
        // this element) since an icon/image suffix (see StatItem::IsIconSuffix())
        // renders outside this element entirely - CountUp overwrites its
        // target's whole innerHTML every frame, so anything meant to survive
        // that can't live inside it.
        const liveRegion = element.closest('.js-key-stat-visual')?.nextElementSibling
        const finalText = liveRegion?.textContent
        const options = {
            startVal: start,
            decimalPlaces: decimals,
            // Jumps straight to the end value instead of counting up.
            duration: reducedMotion.matches ? 0 : duration,
            prefix: prefix !== '' ? prefix : '',
            suffix: suffix !== '' ? suffix : '',
            // Runs its own IntersectionObserver internally and starts once the
            // element scrolls into view, rather than animating immediately.
            autoAnimate: true,
            autoAnimateOnce: true,
            onCompleteCallback: () => {
                if (!liveRegion) return
                // Re-set (rather than just leave it) to force the aria-live
                // mutation that makes screen readers actually announce it.
                liveRegion.textContent = ''
                liveRegion.textContent = finalText
            },
        }
        const countUp = new CountUp(element, end, options)
        if (countUp.error) {
            console.error('countup js err ', countUp.error)
        }
    }
}
export default countUpCounter
